import { Cookie } from '@vue-util/cookie';
import { cookies } from 'config';
import type { mcomUserInfo, bcomUserInfo } from '~/composables/user/types';

export function getUserIdFromCookie() {
  return Cookie.get(cookies.userId);
}

export function getUserGuidFromCookie() {
  return Cookie.get(cookies.userGuid);
}

export function getBagGuidFromCookie() {
  return Cookie.get(cookies.bagGuid);
}

export function getIsSignedInFromCookie() {
  return Cookie.get(cookies.signedIn) === '1';
}

export function getRawUserInfoFromLocalStorage(userId: string | undefined): mcomUserInfo | bcomUserInfo | null {
  const userInfoLS = localStorage.getItem(`hnfsr_${userId}`);
  if (!userId || !userInfoLS) return null;
  try {
    return JSON.parse(userInfoLS);
  } catch {
    /* istanbul ignore next */
    console.error('Error parsing user data');
    return null;
  }
}
